import config from 'shared/config';

export const fb = 'https://fb.me/thedollargame';
export const tw = 'https://twitter.com/the_dollar_game';
export const email = 'feedback@thedollargame.io';
export const rd = 'https://reddit.com/r/thedollargame';
export const ok = 'https://ok.ru/group/55822418706461';
export const okApp = `https://ok.ru/game/${config.ok.appID}`;
